import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function verifyAccessToken() {
  try {
    const res = await fetch(`${BACKEND_URL}/user/verify`, {
      method: "GET",
      credentials: "include",
      cache: "no-store",
    });

    const ct = res.headers.get("content-type") || "";
    const data = ct.includes("application/json")
      ? await res.json().catch(() => null)
      : null;

    if (data) {
      return {
        ...data,
        ...normalizeApiMessage(data, `HTTP_${res.status}`),
      };
    }

    return { success: false, message: `HTTP_${res.status}`, code: res.status };
  } catch (err) {
    console.error("verifyAccessToken failed:", err);
    return {
      success: false,
      message: "Network error",
      messageKey: "api.common.networkError",
      code: "NETWORK_ERROR",
    };
  }
}
